<template>
    <div class="page">
        <div class="topView">
            <div class="topViewL" v-if="detailData != null">
                <div>订单详情</div>
            </div>
            <div class="topViewR" v-if="online_order_data != null">
                <el-button type="warning" plain
                    v-if="online_order_data.distribution_type == 1 && (detailData.state == 5 || detailData.state == 8)"
                    @click="drawerWuliuxinxi_state = true">物流信息</el-button>
                <el-button type="warning" plain v-if="detailData.state == 3"
                    @click="handelConfirmClick">确认发货</el-button>
                <el-button type="warning" plain v-if="detailData.state == 3"
                    @click="handelBeihuo">备货完成</el-button>
                <el-button type="warning" plain v-if="online_order_data.distribution_type == 2 && detailData.state == 5"
                    @click="handelHexiao">核销提货</el-button>
                <el-button type="warning" plain v-if="show" @click="handelGetPickUp">生成码</el-button>
                <el-button type="warning" v-if="online_order_data.distribution_type == 1 && detailData.state == 5" plain
                    @click="handelReceivingClick">确认收货</el-button>
                <el-button type="warning" plain @click="$router.back();">返回</el-button>
            </div>
        </div>
        <div class="detailView" v-if="detailData != null">
            <div class="detailViewName">订单信息</div>
            <div class="detailRow">
                <div class="detailCol">
                    <div>订单编号：</div>
                    <div>{{ detailData.no }}</div>
                </div>
                <div class="detailCol">
                    <div>下单日期：</div>
                    <div>{{ $public.FTime(detailData.create_time, "YYYY-MM-DD HH:mm:ss") }}</div>
                </div>
                <div class="detailCol">
                    <div>订单状态：</div>
                    <div v-if="detailData.state == 1">已创建</div>
                    <div v-if="detailData.state == 2">支付中</div>
                    <div v-if="detailData.state == 3">支付成功</div>
                    <div v-if="detailData.state == 5">已发货</div>
                    <div v-if="detailData.state == 8">已完成</div>
                    <div v-if="detailData.state == -2">已取消</div>
                    <div v-if="detailData.state == -3">退款中</div>
                    <div v-if="detailData.state == -4">退款成功</div>
                </div>
                <div class="detailCol">
                    <div>订单备注：</div>
                    <div>{{ detailData.remark }}</div>
                </div>
            </div>
            <div class="detailRow">
                <div class="detailCol">
                    <div>用户：</div>
                    <div>{{ user_info.nick_name }}</div>
                </div>
                <div class="detailCol">
                    <div>电话：</div>
                    <div>{{ user_info.user_mobile }}</div>
                </div>
                <div class="detailCol">
                    <div>结算方式：</div>
                    <template v-if="detailData.pay_info != null">
                        <span v-for="(item, index) in detailData.pay_info.pay_list" :key="index">
                            <template v-if="item.pay_type == 1">支付宝</template>
                            <template v-if="item.pay_type == 2">微信</template>
                            <template v-if="item.pay_type == 7">余额</template>
                            <template v-if="item.pay_type == 9">积分</template>
                            <template v-if="item.pay_type == 17">拉卡拉</template>
                        </span>
                    </template>
                </div>
                <div class="detailCol">
                    <div>结算金额：</div>
                    <div>{{ detailData.total_price }}</div>
                </div>
            </div>
            <div class="detailRow">
                <div class="detailCol">
                    <div>优惠券:</div>
                    <span v-if="detailData.coupon_list && detailData.coupon_list.length > 0">
                        <span style="padding-right: 30px" v-for="(item, index) in detailData.coupon_list" :key="index">{{
                            item.coupon_name }}</span>
                    </span>
                </div>
                <div class="detailCol">
                    <div>优惠金额：</div>
                    <div>{{ (detailData.order_price + detailData.postage - detailData.total_price).toFixed(2) }}</div>
                </div>
                <div class="detailCol">
                    <div>总计金额：</div>
                    <div>{{ detailData.total_price }}</div>
                </div>
                <div class="detailCol">
                    <div>交易平台：</div>
                    <div>{{ detailData.order_platform }}</div>
                </div>
            </div>
            <div class="detailRow">
                <div class="detailCol">
                    <div>配送方式：</div>
                    <div v-if="online_order_data.distribution_type == 1">邮递配送</div>
                    <div v-if="online_order_data.distribution_type == 2">门店自提</div>
                </div>
                <div class="detailCol">
                    <div>配送地址：</div>
                    <div v-if="online_order_data.distribution_type == 1">{{ online_order_data == null ? '--' :
                        ship_adddress.city_name + ship_adddress.district_name
                    }}</div>
                    <div v-if="online_order_data.distribution_type == 2 && distribution_shop != null">{{
                        distribution_shop.shop_name }}
                        {{ pick_up_store.day }}{{ pick_up_store.time }}门店自提

                    </div>
                </div>
                <div class="detailCol">
                    <div>运费：</div>
                    <div>{{ detailData.postage }}</div>
                </div>
                <div class="detailCol" v-if="online_order_data.distribution_type == 2">
                    <div>核销码：</div>
                    <div>{{ pick_up_store == null ? "--" : pick_up_store.code }}</div>
                </div>

            </div>
        </div>
        <div class="tableWrap">
            <div class="tableView">
                <el-table :data="tableData" style="width: 100%" :default-expand-all="isExpand">
                    <el-table-column type="expand">
                        <template slot-scope="scope">
                            <div v-for="(item, index) in scope.row.order_item_goods_list" :key="index" class="codeItem">
                                <div>{{ item.custom_code }} <span v-if="item.goods_type == 8">{{ item.goods_name }}</span>
                                </div>
                                <i class="el-icon-error" style="font-size: 16px;"
                                    @click="handelDeleteClick(scope.$index, index)" v-if="item.goods_type != 8"></i>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="goods_name" label="商品">
                    </el-table-column>
                    <el-table-column prop="sku_value" label="规格">
                    </el-table-column>
                    <el-table-column prop="unit" label="单位">
                    </el-table-column>
                    <el-table-column prop="original_price" label="标准价">
                    </el-table-column>
                    <el-table-column label="活动">
                        <template slot-scope='scope'>
                            {{ scope.row.activity_info == null ? '--' : scope.row.activity_info.activity_name }}
                        </template>
                    </el-table-column>
                    <el-table-column label="优惠券">
                        <template slot-scope='scope'>
                            {{ scope.row.coupon_list == null ? '--' : scope.row.coupon_list.coupon_name }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="price" label="优惠价">
                    </el-table-column>
                    <el-table-column prop="num" label="数量">
                    </el-table-column>
                    <el-table-column label="支付金额">
                        <template slot-scope="scope">{{ scope.row.price * scope.row.num }}</template>
                    </el-table-column>
                    <el-table-column label="销售人员" width="200">
                        <template slot-scope="scope">
                            <span v-for="item in scope.row.sales_list" :key="item.sales_id">
                                {{ item.sales_name }}
                            </span>
                            <el-button v-if="scope.row.sales_list[0]" type="text" @click="changeStaff(scope.row)">修改</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <!-- 修改销售人员 -->
        <div v-if="curStaffId_state">
            <el-dialog title="修改销售人员" :visible="true" width="300px" @close="curStaffId_state = false"
                :close-on-click-modal="false">
                <div>
                    <el-select v-model="curStaffId" multiple filterable placeholder="请选择" size="mini">
                        <el-option popper-class="select" v-for="item in staffList" :key="item._id"
                            :label="item.basic_info.nick_name" :value="item._id"></el-option>
                    </el-select>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button size="mini" @click="curStaffId_state = false">取 消</el-button>
                    <el-button size="mini" type="warning" @click="submit_curStaffId">确 定</el-button>
                </span>
            </el-dialog>
        </div>
        <el-dialog title="自提订单核销" :modal-append-to-body="false" :visible.sync="dialogconfirm_state" width="20%">
            <!--  :before-close="handleClose" -->
            <el-form>
                <el-form-item label="录入核销码">
                    <el-input type="input" v-model="pick_up_store_code"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogconfirm_state = false">取 消</el-button>
                <el-button type="primary" @click="confirmSort">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 填写单号弹框 -->
        <div v-if="drawerTianxiedanhao_state">
            <drawerTianxiedanhao @closeOn="handleTianxiedanhaoClose" :comState="drawerTianxiedanhao_state"
                :navData="detailData" :navType="1">
            </drawerTianxiedanhao>
        </div>
        <!-- 物流信息弹框 -->
        <div v-if="drawerWuliuxinxi_state">
            <drawerWuliuxinxi @closeOn="drawerWuliuxinxi_state = false" :comState="drawerWuliuxinxi_state"
                :orderNo="detailData.no">
            </drawerWuliuxinxi>
        </div>
    </div>
</template>

<script>
import drawerTianxiedanhao from "./drawerTianxiedanhao.vue"
import drawerWuliuxinxi from "./drawerWuliuxinxi.vue"
export default {
    components: {
        drawerTianxiedanhao,
        drawerWuliuxinxi
    },
    data() {
        return {
            curRow: {},
            curStaffId_state: false,
            curStaffId: [],
            curStaff: [], // 销售人员
            staffList: [], //销售人员列表
            staffList1: [], //销售人员列表
            tableData: [],
            user_info: [],
            online_order_data: [], //配送方式
            ship_adddress: [],
            isExpand: true,
            code: '', //录入条码
            detailData: [],//录入条码信息
            drawerWuliuxinxi_state: false,//物流信息弹框
            drawerTianxiedanhao_state: false, //确认发货弹框
            dialogconfirm_state: false, //核销
            id: this.$route.query.id,
            distribution_shop: [],
            pick_up_store: [],
            pick_up_store_code: '',
            show: false,
            showB: false,

        }
    },
    mounted() {
        this.getDetailData()
        this.getStaffList();

    },
    methods: {
        // 修改销售人员
        changeStaff(row) {
            this.curRow = row;
            this.curStaffId = [];
            if (row.sales_list && row.sales_list.length) {
                for (let b = 0; b < row.sales_list.length; b++) {
                    this.curStaffId.push(row.sales_list[b].sales_id);
                }
            }

            this.curStaffId_state = true;
        },
        submit_curStaffId() {
            let sales_list = [];
            for (let i = 0; i < this.curStaffId.length; i++) {
                sales_list.push({
                    sales_id: this.curStaffId[i],
                    sales_name: this.$public.getMatchingItem(
                        this.staffList, "_id", this.curStaffId[i]).basic_info.nick_name,
                });
            }
            let params = {
                order_id: this.detailData.no,
                order_item_id: this.curRow._id,
                sales_list: sales_list,
            };
            let loading = this.$loading();
            this.$http
                .post(
                    process.env.VUE_APP_Url_order +
                    "/api/OffLineOrder/UpdateSaleManByOrderItemId",
                    params
                )
                .then((res) => {
                    loading.close();

                    if (res.code === 0) {
                        this.curStaffId_state = false;
                        this.getDetailData()

                    }
                });
        },
        getStaffList() {
            let params = {
                keyword: "",
                pageIndex: 1,
                pageSize: 500,
            };
            this.$http.get("/api/Staff/List", params).then((res) => {
                if (res.code == 0) {
                    this.staffList = res.data.data;
                    res.data.data.forEach((item) => {
                        const obj = {
                            id: item._id,
                            name: item.basic_info.nick_name,
                        };
                        this.staffList1.push(obj);
                    });
                }
            });
        },
        // 生成核销码
        handelGetPickUp(row) {
            let params = {
                order_no: this.detailData.no
            }
            console.log(params, "params");
            this.$http.get(process.env.VUE_APP_Url_order + '/api/OffLineOrder/CreatePickUpStoreCode', params).then((res) => {
                if (res.code == 0) {
                    this.$message({
                        message: '已生成核销码',
                        type: 'success'
                    });
                    this.getDetailData()
                }
            })

        },
        //确认收货
        handelReceivingClick() {
            let params = {
                orderNo: this.detailData.no
            }
            this.$http.post(process.env.VUE_APP_AppAdmin + '/api/Logistics/finish/receiving', params).then((res) => {
                if (res.code == 0) {
                    console.log(res.data)
                    this.$message({
                        type: 'success',
                        message: '已收货'
                    });
                    this.getDetailData()
                }
            })
        },
        //确认发货 邮递
        handelConfirmClick() {
        
                this.detailData.order_item_list = this.tableData;
                this.drawerTianxiedanhao_state = true;
            
        },
        // 备货完成
        handelBeihuo() {
                this.detailData.order_item_list = this.tableData;
                let params = {}
                params = {
                    orderNo: this.detailData.no,
                    goodsInfo: [],
                    expressCompanyCode: this.detailData.expressCompanyCode,
                    expressNo: this.detailData.expressNo
                }

                this.detailData.order_item_list.map(item => {
                    params.goodsInfo.push({
                        goodsId: item.goods_id,
                        skuId: item.skus_id,
                        unitId: item.packing_way_id,
                        unit: item.unit,
                    })
                })
                console.log(params)
                this.$http.post(process.env.VUE_APP_AppAdmin + '/api/Logistics/goods/Deliver', params).then((res) => {
                    if (res.code == 0) {
                        console.log(res.data)
                        this.$message({
                            type: 'success',
                            message: '已发货'
                        });
                        this.showB = false
                        this.getDetailData()
                        this.dialogconfirm_state = false
                    }
                })
            
        },
        // 核销提货
        handelHexiao() {
            this.dialogconfirm_state = true
        },
        //核销确定
        confirmSort() {
            let params = {
                pick_up_store_code: this.pick_up_store_code
            }
            this.$http.get(process.env.VUE_APP_Url_order + '/api/OffLineOrder/get/pick_up_store_code', params).then((res) => {
                if (res.code == 0) {
                    this.handleSunmitClick()
                }
            })
        },
        handleSunmitClick() {
            let params = {
                order_id: this.detailData._id
            }
            this.$http.get(process.env.VUE_APP_Url_order + '/api/OffLineOrder/havegood', params).then((res) => {
                if (res.code == 0) {
                    this.$message({
                        type: 'success',
                        message: '已收货'
                    });
                    this.$emit("closeOn", {
                        type: 'submit'
                    });
                }
            })
        },
        //关闭弹框
        handleTianxiedanhaoClose(val) {
            this.drawerTianxiedanhao_state = false;
            if (val.type == "submit") {
                this.getDetailData()
            }
        },
        //删除
        handelDeleteClick(index1, index2) {
            this.tableData[index1].order_item_goods_list.splice(index2, 1);
            this.$set(this.tableData, index1, this.tableData[index1])
        },
        // //录入条码
        // handelInputClick() {
        //     let params = {
        //         barcode: this.code
        //     }
        //     this.$http.get(process.env.VUE_APP_Url_baseData + '/api/product/goods/from/code', params).then((res) => {
        //         if (res.code == 0) {
        //             if (res.data.customCodeStatus.id == 1 || res.data.customCodeStatus.id == 2 || res.data.customCodeStatus.id == 3) {
        //                 let isOK = false;
        //                 let isCount = false;
        //                 this.showB = true
        //                 this.tableData.map((item, index) => {
        //                     console.log(item.skus_id)
        //                     if (item.skus_id == res.data.skus) {
        //                         isOK = true;
        //                         if (item.order_item_goods_list == null) {
        //                             item.order_item_goods_list = [];
        //                         }
        //                         if (item.order_item_goods_list.length < item.num) {
        //                             isCount = true;
        //                             item.code.push({
        //                                 code: res.data.customCode,
        //                                 validityStopDate: res.data.validityStopDate,
        //                                 costPrice: res.data.costPrice,
        //                             })
        //                             item.order_item_goods_list.push({
        //                                 goods_id: res.data.goodsId,
        //                                 goods_name: res.data.goodsName,
        //                                 model: res.data.skuValue,
        //                                 skus: res.data.skus,
        //                                 unit: res.data.unit,
        //                                 unit_id: res.data.unitId,
        //                                 goods_sales_model: 1,
        //                                 count: 1,
        //                                 goods_type: res.data.goodsType,
        //                                 cost_price: res.data.costPrice,
        //                                 custom_code: res.data.customCode,
        //                             })
        //                             this.$set(this.tableData, index, this.tableData[index])

        //                         }
        //                     }
        //                 })
        //                 if (isOK == false) {
        //                     this.$message({
        //                         type: 'error',
        //                         message: '此订单不包含该条码商品'
        //                     });
        //                     return
        //                 }
        //                 if (isCount == false) {
        //                     this.$message({
        //                         type: 'error',
        //                         message: '条码数量超过了订单商品数量'
        //                     });
        //                     return
        //                 }
        //             } else {
        //                 this.$message({
        //                     type: 'error',
        //                     message: '该条码已使用'
        //                 });
        //             }
        //         }
        //     })
        // },
        //获取详情
        getDetailData() {
            let params = {
                id: this.id
            }
            this.$http.get(process.env.VUE_APP_Url_order + '/api/OnLineOrder/get', params).then((res) => {
                if (res.code == 0) {
                    this.tableData = []
                    this.detailData = res.data;
                    this.user_info = res.data.user_info;
                    this.online_order_data = res.data.online_order_data
                    this.ship_adddress = res.data.online_order_data.ship_adddress,
                        this.distribution_shop = res.data.online_order_data.distribution_shop
                    this.pick_up_store = res.data.online_order_data.pick_up_store
                    if (res.data.state == 1 || res.data.state == 2 || res.data.state == 3) {
                        res.data.order_item_list.map(item => {
                            item.order_code_list = [];
                        })
                    }
                    if (res.data.state == 3 && res.data.online_order_data.distribution_type == 2 && res.data.order_item_list[0].order_item_goods_list != null && res.data.order_item_list[0].order_item_goods_list.length > 0) {
                        this.show = true;
                    } else {

                        this.show = false;
                    }
                    res.data.order_item_list.map(item => {
                        item.code = [];
                    })
                    this.tableData = res.data.order_item_list;
                    // for (let i = 0; i < this.tableData.order_item_list.length; i++) {
                    //     this.tableData[i].staff = ''

                    //     if (this.tableData.order_item_list[i].sales_list) {

                    //         for (let b = 0; b < this.tableData.order_item_list[i].sales_list.length; b++) {
                    //             this.tableData[i].staff += this.tableData.order_item_list[i].sales_list[b].sales_name + " ";
                    //         }
                    //     }
                    // }

                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.page {
    padding: 16px 16px 0 16px;
    height: 100%;
    box-sizing: border-box;

    .topView {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;
        background-color: #fff;
        padding: 10px 20px;

        .topViewL {
            display: flex;
            align-items: center;
            font-size: 18px;
            color: #343440;
            font-weight: bold;
        }
    }

    .detailView {
        margin-bottom: 16px;
        padding: 24px 32px;
        background: #fff;
        border-radius: 16px;

        .detailViewName {
            font-size: 16px;
            font-weight: bold;
            color: #343440;
        }

        .detailRow {
            display: flex;
            align-items: center;
            margin-top: 32px;
            font-size: 14px;
            justify-content: space-between;

            .detailCol {
                display: flex;
                align-items: center;
                width: 24%;

                div:nth-of-type(1) {
                    width: 70px;
                    text-align: right;
                    color: #343440;
                    font-weight: 400;
                }

                div:nth-of-type(2) {
                    flex: 1;
                  
                    color: #343440;
                    font-weight: 500;
                }
            }
        }

    }

    .tableWrap {
        padding: 16px;
        background: #fff;
        border-radius: 8px;
        height: 440px;
        display: flex;
        flex-direction: column;

        .tableTitle {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 40px;
            line-height: 40px;

            .tableTitleL {
                font-size: 16px;
                font-weight: bold;
                margin-left: 16px;
            }

            .tableTitleR {
                display: flex;
                align-items: center;
            }
        }

        .tableView {
            flex: 1;
            overflow-y: scroll;
            margin-top: 10px;

            .codeItem {
                // width: 146px;
                height: 32px;
                margin-left: 16px;
                background: #F7F7FA;
                font-size: 14px;
                display: flex;
                align-items: center;
                justify-content: center;
                float: left;
                margin-bottom: 10px;
                border-radius: 4px;
                padding: 0 10px;

                div {
                    margin-right: 10px;
                }
            }
        }
    }

    .tableView::-webkit-scrollbar {
        display: none;
    }
}
</style>
